import React from "react";
import prodA from "../assets/products/die-cutting-progressive-part.png";
import prodB from "../assets/products/packaging-product-progressive-part.png";
import prodC from "../assets/products/hot-die-cutting-part.png";
import prodD from "../assets/products/air-conditioner.png";
import productBanner from "../assets/products/product_banner.png"; // ganti sesuai gambar banner kamu

const ProductALL = () => {
  const products = [
    {
      id: 1,
      title: "Die-Cutting Progressive Part",
      image: prodA,
      description:
        "Produk hasil proses pemotongan berlapis menggunakan teknologi Progressive Die-Cutting. Cocok untuk kebutuhan otomotif dan elektronik yang memerlukan presisi tinggi serta efisiensi produksi. Proses ini menghasilkan komponen foam, felt, dan adhesive parts dengan akurasi dimensi yang stabil.",
    },
    {
      id: 2,
      title: "Packaging Product & Part",
      image: prodB,
      description:
        "Komponen kemasan industri yang dirancang khusus untuk melindungi part otomotif dan elektronik dari benturan dan goresan. Menggunakan bahan PE foam, EPE, laminated sheet, dan material ringan lain yang tahan lama.",
    },
    {
      id: 3,
      title: "Hot Die-Cutting Progressive Part",
      image: prodC,
      description:
        "Proses pemotongan panas berpresisi tinggi untuk material adhesive, insulasi, dan foam. Cocok untuk komponen yang memerlukan bentuk kompleks dan ketahanan suhu tinggi pada sistem elektronik dan AC.",
    },
    {
      id: 4,
      title: "Air Conditioner (AC) Part",
      image: prodD,
      description:
        "Komponen pendukung sistem pendingin udara kendaraan, seperti insulator, ducting foam, dan sealing gasket. Didesain untuk meningkatkan efisiensi pendinginan, mengurangi kebisingan, dan memperpanjang usia sistem HVAC.",
    },
  ];

  return (
    <section
      id="product"
      style={{
        paddingTop: "100px", // posisinya pas di bawah navbar
        backgroundColor: "white",
      }}
    >
      {/* === Banner Product === */}
      <div
        className="product-banner"
        style={{
          position: "relative",
          width: "100%",
          height: "300px",
          backgroundImage: `url(${productBanner})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain", // agar tidak kepotong
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
        }}
      >
        {/* Overlay Transparan */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>

        <h1
          style={{
            position: "relative",
            fontSize: "2.5rem",
            fontWeight: "bold",
            zIndex: 1,
            textShadow: "2px 2px 5px rgba(0,0,0,0.5)",
          }}
        >
          Our Product
        </h1>
      </div>

      {/* === Konten Produk === */}
      <div
        style={{
          padding: "4rem 2rem 2rem 2rem",
          background: "linear-gradient(135deg, #bbf7d0, #fef08a, #fcffbf)",
        }}
      >
        {/* <h2
          style={{
            textAlign: "center",
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#111827",
            marginBottom: "2.5rem",
          }}
        >
          Our Product Catalog
        </h2> */}

        <div className="product-grid">
          {products.map((prod) => (
            <div
              key={prod.id}
              className="product-card"
              style={{
                display: "flex",
                flexDirection: "row",
                background: "white",
                borderRadius: "18px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                overflow: "hidden",
                height: "380px",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 14px 30px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 10px 25px rgba(0,0,0,0.1)";
              }}
            >
              {/* Gambar */}
              <div
                className="product-image"
                style={{
                  flex: "1 1 45%",
                  overflow: "hidden",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f3f4f6",
                }}
              >
                <img
                  src={prod.image}
                  alt={prod.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    transition: "transform 0.6s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.03)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1.0)")
                  }
                />
              </div>

              {/* Deskripsi */}
              <div
                className="product-desc"
                style={{
                  flex: "1 1 55%",
                  padding: "2rem 2.5rem",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "justify",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "#111827",
                    marginBottom: "1rem",
                  }}
                >
                  {prod.title}
                </h3>
                <p
                  style={{
                    color: "#4b5563",
                    fontSize: "1rem",
                    lineHeight: "1.9",
                  }}
                >
                  {prod.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* === Responsive CSS === */}
      <style>{`
        /* Tablet */
        @media (max-width: 1024px) {
          #product {
            padding-top: 95px !important;
          }
          .product-banner {
            height: 250px !important;
          }
        }

        /* Mobile */
        @media (max-width: 768px) {
          #product {
            padding-top: 90px !important;
          }
          .product-banner {
            height: 220px !important;
          }
          .product-card {
            flex-direction: column !important;
            height: auto !important;
          }
          .product-image {
            width: 100%;
            height: 230px;
          }
          .product-desc {
            padding: 1.5rem !important;
          }
          .product-desc h3 {
            text-align: center !important;
            font-size: 1.4rem !important;
          }
          .product-desc p {
            font-size: 1rem;
          }
        }

        /* HP kecil */
        @media (max-width: 480px) {
          #product {
            padding-top: 85px !important;
          }
          .product-banner {
            height: 200px !important;
          }
        }

        .product-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 2.5rem;
          max-width: 1400px;
          margin: 0 auto;
        }

        @media (min-width: 1024px) {
          .product-grid {
            grid-template-columns: repeat(auto-fit, minmax(600px, 1fr));
          }
        }
      `}</style>
    </section>
  );
};

export default ProductALL;
